import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface workflowAnalyticState {
  loading: boolean;
  error: string | null;
  response: any;
}

const initialState: workflowAnalyticState = {
  loading: false,
  error: null,
  response: null,
};

export const workflowAnalyticSlice = createSlice({
  name: "workflowAnalytic",
  initialState,
  reducers: {
    triggerAnalyticsPipeRequest: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    triggerAnalyticsPipeSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.response = action.payload;
      state.error = null;
    },
    triggerAnalyticsPipeFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const workflowAnalyticActions = workflowAnalyticSlice.actions;
export const workflowAnalyticReducer = workflowAnalyticSlice.reducer;
